// React and Redux Dependencies
import React, { useEffect, useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// Redux Actions
import { setSelected, getBudgetList } from 'reduxStore/actions/budgetManagement';

// Common Components, Utils and Constants
import Loader from 'common/Loader/Loader';
import { APPLICATION_CONSTANTS } from 'AppConstants';
import { BUDGET_TABLE_COLUMNS, tableTextsConfig } from '../config';
import ApiError from 'common/ApiError/ApiError';
import NoData from 'common/noData';
import { TableListing } from 'common/TableListing';

// Styles
import { BudgetListingWrapper } from '../styles';

const BudgetOverviewListing = () => {
    const dispatch = useDispatch();

    const {
        data = [],
        error: listApiError = true,
    } = useSelector((state) => state?.budgetManagement?.budgetList || {});

    const apiStatus = useSelector((state) => state?.budgetManagement?.apiStatus || '');
    const listLoading = apiStatus === APPLICATION_CONSTANTS.LOADING;

    // will be used later
    const selectedRecords = useSelector(
        (state) => state?.budgetManagement?.selectedRecords || {}
    );

    const isAllSelected = useSelector(
        (state) => state?.budgetManagement?.isAllSelected
    );

    const hasData = data?.length > 0;

    /** Fetch budget list on component load */
    useEffect(() => {
        dispatch(getBudgetList({ limit: 100, offset: 0 }));
    }, [dispatch]);

    /** Memoized API error block */
    const ApiErrorComp = useMemo(
        () => (
            <ApiError
                $bg="#fbfbfb"
                textSize="14"
                imgMargin="25px"
                headSize="20px"
                bottom_P="40"
                top_P="18"
                imgWidth="150px"
                imgHeight="150px"
                $direction="column"
                justify="center"
                align="center"
                ctatext="Click here to retry"
                txtAlign="center"
            />
        ),
        []
    );

    const handleCheckBox = useCallback(
        ({ checked, isAllSelected, data: rowData }) => {
            const selectedData = isAllSelected ? data : [rowData];
            dispatch(
                setSelected({
                    items: selectedData,
                    selectAll: isAllSelected,
                    checked
                })
            );
        },
        [dispatch, data]
    );
    const LoaderComp = (
        <Loader
            show={listLoading}
            size={hasData > 0 ? '10' : '16'}
            color='#f17531'
        />
    );
    return (
        <BudgetListingWrapper bdrRad="8px">
            <TableListing
                childProps={{
                    container: { bdrRad: '8px' },
                    table: {
                        stickyHeader: true,
                    }
                }}
                data={data}
                columns={BUDGET_TABLE_COLUMNS}
                bdrRad="8px"
                rowHt={56}
                pageCount={7}
                isAllSelected={isAllSelected}
                isLoading={listLoading}
                isApiError={listApiError && !hasData}
                ApiError={ApiErrorComp}
                reverseSort
                idKey="budget_id"
                NoData={listLoading ? null : (
                    <NoData
                        bottom_M="120"
                        top_P="120"
                        heading={tableTextsConfig.NO_BUDGET_FOUND}
                    />
                )}
                Loader={LoaderComp}
                handleCheckBox={handleCheckBox}
                selectedRecords={selectedRecords}
            />
        </BudgetListingWrapper>
    );
};

export default React.memo(BudgetOverviewListing);
